module.exports = __webpack_public_path__ + "img/CN.4223cac8.webp";